import React from 'react';
import { Main } from './page'
import './App.css';

function App() {
  return (
    <Main />
  );
}

export default App;
